import type { DataTexture } from 'three';

export const SHADOW_CACHE_VERSION = 'accumulative-shadow-v4-camera-relative';

export interface ShadowCacheEntry {
    cacheKey: string
    texture: DataTexture
}

// The renderbot is a long-lived process that repeatedly revisits a finite set
// of product models. Keep every completed bake for the lifetime of its page so
// returning to any previously rendered model is an immediate cache hit.
const shadowCache = new Map<string, ShadowCacheEntry>();

export function getShadow(cacheKey:string):ShadowCacheEntry|undefined {
    return shadowCache.get(cacheKey);
}

export function storeShadow(entry:ShadowCacheEntry):ShadowCacheEntry {
    const cachedEntry = shadowCache.get(entry.cacheKey);
    if(cachedEntry) return cachedEntry;

    shadowCache.set(entry.cacheKey, entry);
    return entry;
}

export function getShadowCacheSize():number {
    return shadowCache.size;
}
